import React from 'react';
import CapRow from '../CapRow';
import CapPopover from '../CapPopover';
import L1ModuleIcon from './L1ModuleIcon';
import DisabledHoverPopover from './DisabledHoverPopover';
import SubModules from './SubModules';
import './_index.scss';
import {
  validateDisabledConfig,
  ArrowedDiv,
  reducerActions,
  FormattedMessageWrapper,
} from './utils';
import CapHeading from '../CapHeading';

const L1ModuleWrapper = ({
  moduleObj,
  index,
  currentState,
  dispatchAction,
  handleRedirectionAndModuleSelection,
  redirectToLink,
  pushDataToGTM,
  leftNavbarExpanded
}) => {
  const {
    name,
    _id,
    displayLabel,
    subModules = [],
    disabled = false,
    disabledConfig = {},
    redirectionType,
    targetLocation,
    url = '',
    isDisabled = false,
    redirectToDifferentDomain = false,
    domainPattern = '',
    patternMapper = {},
  } = moduleObj;
  const itemSelected = _id ? _id === currentState?.selectedL1Module?._id : name === currentState?.selectedL1Module?.name;
  const itemHovered = name === currentState.hoveredL1Module?.name;
  const l1_itemHovered = itemHovered && name;
  const l1_urlEnable = currentState.hoveredL1Module?.url;

  const handleDirectL1CickAndRedirection = () => {
    pushDataToGTM('clickDirectRedirectionL1Item', {
      name,
      redirectionType,
      targetLocation,
      url,
    });
    redirectToLink({ url, targetLocation, redirectionType, redirectToDifferentDomain, domainPattern, patternMapper, hoveredRedirectionModule: l1_itemHovered });
  };

  const l2NotRequired = !subModules?.length;
  const PopOverComponent = !isDisabled ? CapPopover : CapRow;


  return (
    <div
      className="l1-popover-wrapper"
      onClick={
        !disabled &&
        !isDisabled &&
        l1_urlEnable &&
        handleDirectL1CickAndRedirection
      }
      onMouseEnter={() =>
        !isDisabled &&
        dispatchAction({
          type: reducerActions.hoveredL1Module,
          value: moduleObj,
        })
      }
      onMouseLeave={() =>
        dispatchAction({
          type: reducerActions.hoveredL1Module,
          value: {...moduleObj,name:''},
        })
      }
    >
      {(leftNavbarExpanded && itemSelected) || (itemHovered && l2NotRequired) ? (
        <>
          <L1ModuleIcon
            moduleObj={moduleObj}
            currentState={currentState}
            dispatchAction={dispatchAction}
          />
          <CapHeading
            className={`l1-module-heading ${disabled ? 'nav-item-disabled' : ''} ${itemSelected ? 'itemSelected' : ''
              }`}
            type="h6"
            disabled={disabled || isDisabled}
            onMouseOver={() =>
              !isDisabled &&
              dispatchAction({
                type: reducerActions.hoveredL1Module,
                value: moduleObj,
              })
            }
          >
            <FormattedMessageWrapper id={displayLabel} message={name} />
          </CapHeading>
        </>
      ) : (
        <PopOverComponent
          content={
            disabled && validateDisabledConfig(disabledConfig) ? (
              <DisabledHoverPopover
                {...disabledConfig}
                title={
                  <FormattedMessageWrapper id={displayLabel} message={name} />
                }
                redirectToLink={redirectToLink}
                pushDataToGTM={pushDataToGTM}
              />
            ) : isDisabled ? (
              ''
            ) : (
              <>
              <SubModules
                l1_itemHovered={l1_itemHovered}
                selectedL1ModuleObj={currentState.hoveredL1Module}
                dispatchAction={dispatchAction}
                handleRedirectionAndModuleSelection={
                  handleRedirectionAndModuleSelection
                }
                currentState={currentState}
                redirectToLink={redirectToLink}
                pushDataToGTM={pushDataToGTM}
              />
              <ArrowedDiv show={itemHovered} moduleIndex={index} />
              </>
            )
          }
          placement="right"
          overlayClassName={`l1-${disabled ? 'disabled' : 'enabled'
            }-popover-container`}
        >
          <CapRow>
            <CapRow>
              <L1ModuleIcon
                moduleObj={moduleObj}
                currentState={currentState}
                dispatchAction={dispatchAction}
              />
              <CapHeading
                className={`l1-module-heading ${disabled || isDisabled ? 'nav-item-disabled' : ''
                  } ${itemSelected ? 'itemSelected' : ''}`}
                type="h6"
                disabled={disabled || isDisabled}
                onMouseOver={() =>
                  !isDisabled &&
                  dispatchAction({
                    type: reducerActions.hoveredL1Module,
                    value: moduleObj,
                  })
                }
              >
                <FormattedMessageWrapper id={displayLabel} message={name} />
              </CapHeading>
            </CapRow>
          </CapRow>
        </PopOverComponent>
      )}
    </div>
  );
};

L1ModuleWrapper.defaultProps = {
  currentState: {},
  moduleObj: {},
  index: 0,
  dispatchAction: () => {},
  handleRedirectionAndModuleSelection: () => {},
  redirectToLink: () => {},
  pushDataToGTM: () => {},
};
export default L1ModuleWrapper;
